import {ApiModule} from './api.module';
import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService]
})
export class ProductActivationApiService {
  constructor(private http: BaseApiService) {
  }

  productActivation(body: ProductActivation): Observable<any> {
    return this.http.post({
      path: '/productactivation/v1/productactivation ',
      body
    });
  }
}

interface PdaReferent {
  cellularPhone: string;
  email?: string;
}

export interface ProductActivation {
  productOfferingId: string;
  type: string;
  custcode: string;
  cslevel: string;
  catalogType: string;
  pdaReferent: PdaReferent;
  quantity: string;
  domain?: string;
  shippingAddress?: string;
  productSpecificationId?: string;
  channel: string;
}
